import React from 'react';
import { FadeIn } from './FadeIn';
import { TrendingUp, Code, Copy, Handshake, SlidersHorizontal } from 'lucide-react';
export function TruthSection() {
  return <section className="bg-cream-100 py-10 md:py-16" data-id="element-276">
      <div className="max-w-3xl mx-auto px-6" data-id="element-277">
        <FadeIn data-id="element-278">
          <div className="text-center mb-6" data-id="element-279">
            <h2 className="text-3xl md:text-4xl mb-2" data-id="element-280">
              Here's The Truth Most Women Don't Know:
            </h2>
            <p className="text-xl text-brown-800" data-id="element-281">Medical bills are often:</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-282">
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-8" data-id="element-283">
            {[{
            label: 'Inflated',
            icon: TrendingUp
          }, {
            label: 'Incorrectly coded',
            icon: Code
          }, {
            label: 'Duplicated',
            icon: Copy
          }, {
            label: 'Negotiable',
            icon: Handshake
          }, {
            label: 'Adjustable',
            icon: SlidersHorizontal
          }].map((item, i) => <span key={i} className="bg-white px-4 py-2 rounded-full text-brown-800 font-medium shadow-sm border border-cream-200 flex items-center" data-id="element-284">
                <item.icon className="w-4 h-4 text-terracotta-500 mr-2" data-id="element-285" />
                {item.label}
              </span>)}
          </div>

          <p className="text-center text-xl md:text-2xl font-semibold text-brown-600" data-id="element-286">
            And middle-income families overpay quietly every single day.
          </p>
        </FadeIn>
      </div>
    </section>;
}